import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ROUTES } from '@/constants/routes';
import { type RootState } from '@/types/app';
import { userLoggedIn } from '@/utils/auth';
import { deriveReferrer } from '@/utils/global';
import { allowedLoyaltyRoutes } from '@/utils/loyalty';
import Error from 'pages/_error';

interface Props {
  children?: React.ReactNode;
}

export const RestrictedAccountRoute = ({ children }: Props) => {
  const [showContent, setShowContent] = useState(false);
  const router = useRouter();
  const loyaltyDriverID = useSelector(
    (state: RootState) => state.app.organization.organization.loyalty_driver_id,
  );

  const currentRoute = router.route;
  const currentRouteAllowed = allowedLoyaltyRoutes(loyaltyDriverID).includes(currentRoute);

  /**
   * Redirect the user to a login screen if loggged out
   */
  useEffect(
    function redirectIfLoggedOut() {
      if (!userLoggedIn()) {
        const referrer = deriveReferrer(router);
        void router.push(`${ROUTES.LOGIN}?referrer=${referrer}`);
      } else {
        setShowContent(true);
      }
    },
    [router],
  );

  if (!showContent) {
    return null;
  }

  if (!currentRouteAllowed) {
    return <Error statusCode={404} />;
  }

  return <>{children}</>;
};
